// extracted by mini-css-extract-plugin
module.exports = {"pitchItem":"PitchItem_pitchItem__3PsR8","number":"PitchItem_number__1_FsN","label":"PitchItem_label__3YUOm","pitchInput":"PitchItem_pitchInput__3m3Hm"};